import React, { memo } from 'react';

import { Avatar, Box, Typography } from '@mui/material';
import { authorAvatarWithBorderStyles } from 'app/shared/styles/authorAvatar.styles';
import PropTypes from 'prop-types';

import { formatCicDateTime, getCicAuthorInitials, getCicDisplayValue } from 'utils/cicReason';

import { enteredByTextStyles, getEnteredByStyles } from './CicEnteredBy.styles';

const CicEnteredBy = ({ name = null, date = null, isCompact = false }) => (
  <Box sx={getEnteredByStyles({ isCompact })}>
    <Avatar sx={authorAvatarWithBorderStyles}>{getCicAuthorInitials(name)}</Avatar>
    <Box sx={enteredByTextStyles}>
      <Typography variant={isCompact ? 'regular12' : 'regular14'}>
        {getCicDisplayValue(name)}
      </Typography>
      <Typography color="text.secondary" variant="regular12">
        {formatCicDateTime(date)}
      </Typography>
    </Box>
  </Box>
);

CicEnteredBy.propTypes = {
  date: PropTypes.string,
  isCompact: PropTypes.bool,
  name: PropTypes.string,
};

export default memo(CicEnteredBy);
